import { IVo } from '@wizeoo/akm-compute-lib';
import { BasicEntity } from '@wizeoo/akm-message-lib';

export class ModelExampleVO implements IVo {
  id: number;
  uid: string;
  domain: string;
  businessUnitCode: string;
  source: BasicEntity;

  // titre du widget
  code: string;
  // type d'objet présenté (Chonocode, Freedata, ..)
  type: string;
  // description présentant le modèle
  trsLabel: string;
  // icon
  seeIcon: boolean;
}
